import { FC } from 'react'

import { SwitchBasedFilter } from '@new/__global/components/Filters'
import { FiltersProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'

interface ShowOffboardedFilterProps extends FiltersProps {
  initialValue?: boolean
  onChange: (value?: boolean) => void
}

export const ShowOffboardedFilter: FC<ShowOffboardedFilterProps> = props => {
  return <SwitchBasedFilter title="Show only offboarded homes" {...props} />
}
